import React, { useEffect, useState, useContext } from "react";
import "./StudentCourses.css";
import { Bell, User } from "lucide-react";
import axios from "axios";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";
import attendClassIcon from "../../assets/attendClassIcon.png";
import myProgressIcon from "../../assets/myProgressIcon.png";
import projectsActivitiesIcon from "../../assets/projectsActivitiesIcon.png";
import Header from "../Header";

const StudentCourses = ({ onSearch, searchValue }) => {
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState(searchValue || "");
  const { userInfo } = useContext(UserContext) || {};

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/fetchStudentRegisteredCourses`,
          { withCredentials: true }
        );
        const courseNames = response.data.courseNames;
        console.log("Backend response:", JSON.stringify(courseNames, null, 2));

        // Fetch teacher IDs for each course using Class_id
        const coursesWithTeacherIds = await Promise.all(
          courseNames.map(async (course) => {
            try {
              if (course.Class_id) {
                console.log(`Fetching teachers for Class_id: ${course.Class_id}, Course_id: ${course.Course_id}, Course_name: ${course.coursename}`);
                const teacherResponse = await axios.get(
                  `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getTeacherIdsViaClassId/${course.Class_id}`,
                  { withCredentials: true }
                );
                if (teacherResponse.data.Teacher_ids && teacherResponse.data.Teacher_ids.length > 0) {
                  return {
                    ...course,
                    teacherIds: teacherResponse.data.Teacher_ids.join(","),
                  };
                } else {
                  console.warn(`No Teacher_ids found for Class_id: ${course.Class_id}`);
                  return { ...course, teacherIds: "" };
                }
              }
              console.warn(`No Class_id for Course_id: ${course.Course_id}, Course_name: ${course.coursename}`);
              return { ...course, teacherIds: "" };
            } catch (err) {
              console.error(`Error fetching teachers for Class_id ${course.Class_id}:`, err);
              return { ...course, teacherIds: "" };
            }
          })
        );

        setCourses(coursesWithTeacherIds);
      } catch (err) {
        console.error("Error fetching courses:", err);
      }
    };
    fetchCourses();
  }, []);

  const filteredCourses = courses.filter((course) =>
    course.coursename.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="courses-background">
      <Header />
      <div className="courses-searchbar">
        <input
          type="text"
          placeholder="Search anything"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            if (onSearch) onSearch(e.target.value);
          }}
        />
      </div>
      <div className="courses-container">
        {filteredCourses.map((course) => (
          <div className="course-wrapper" key={course.Course_id}>
            <div className="course--card" style={{flexDirection:"row"}}>
              <div>
                <h3 className="course-card-title">{course.coursename}</h3>
                <div className="course-card-links">
                  <Link
                    to={`/AttendClass?classLink=${encodeURIComponent(
                      course.classlink || ""
                    )}&coursename=${encodeURIComponent(
                      course.coursename || ""
                    )}&Course_id=${course.Course_id || ""}&teacherIds=${course.teacherIds ? encodeURIComponent(course.teacherIds) : ""
                      }`}
                    className="course-card-link-attendClass"
                  >
                    <img
                      src={attendClassIcon}
                      alt="Attend Class"
                      className="course-link-icon"
                    />
                    Attend Class
                  </Link>

                  <Link
                    to={`/MyProgress/${course.Course_id}`}
                    state={{
                      courseId: course.Course_id,
                      courseName: course.coursename,
                    }}
                    className="course-card-link-progress"
                  >
                    <img
                      src={myProgressIcon}
                      alt="My Progress"
                      className="course-link-icon"
                    />
                    My Progress
                  </Link>

                  <Link
                    to={`/ActivitiesAndProjects/${course.Course_id}`}
                    state={{
                      courseId: course.Course_id,
                      courseName: course.coursename,
                    }}
                    className="course-card-link-AandP"
                  >
                    <img
                      src={projectsActivitiesIcon}
                      alt="Projects and Activities"
                      className="course-link-icon"
                    />
                    Projects and Activities
                  </Link>
                </div>
              </div>
              <div className="course-card-right">
                {course?.course_image && (
                  <img
                    src={course?.course_image}
                    alt={course?.coursename}
                    className="course-card-image"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                )}
              </div>
            </div>


          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentCourses;